module.exports = {"en":{"manage_profiles":"Manage profiles"},"de":{"manage_profiles":"Profile verwalten"},"fr":{"manage_profiles":"Gérer les profils"},"ru":{"manage_profiles":"Управление профилями"},"zh":{"manage_profiles":"管理配置文件"}}


//////////////////
// WEBPACK FOOTER
// ./src/features/ProfileSelector/localization/localization.json
// module id = 908
// module chunks = 0